import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Landmark, GraduationCap, Truck, ShoppingCart, HeartPulse } from 'lucide-react';

const industries = [
  { icon: <Landmark size={28} />, name: 'Banking & Finance', desc: 'Secure, compliant, and scalable fintech solutions.' },
  { icon: <HeartPulse size={28} />, name: 'Healthcare', desc: 'Patient-centric digital health and management systems.' },
  { icon: <ShoppingCart size={28} />, name: 'E-Commerce & Retail', desc: 'High-conversion storefronts and backend solutions.' },
  { icon: <Truck size={28} />, name: 'Logistics & Supply', desc: 'Real-time tracking and automated operations software.' },
  { icon: <Building2 size={28} />, name: 'Real Estate', desc: 'Property management and immersive viewing platforms.' },
  { icon: <GraduationCap size={28} />, name: 'EdTech', desc: 'Interactive learning and campus management systems.' },
];

const Industries = () => {
  return (
    <section className="py-24 bg-transparent relative overflow-hidden">
      {/* Decorative ultra-light background accents */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-slate-50 to-transparent"></div>
      
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="flex flex-col lg:flex-row gap-16">
          <div className="lg:w-1/3">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">
                Industries We <br/><span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Transform</span>
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                With a deep understanding of domain-specific challenges, we deliver tailored architecture and software solutions that empower organizations globally.
              </p>
              <button className="text-blue-600 font-semibold flex items-center gap-2 hover:gap-3 transition-all">
                Explore Case Studies &rarr; 
              </button>
            </motion.div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {industries.map((ind, i) => (
              <motion.div
                key={ind.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                className="group p-6 rounded-3xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(59,130,246,0.1)] transition-all cursor-pointer relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-blue-50 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className="w-14 h-14 rounded-2xl bg-slate-50 text-slate-800 flex items-center justify-center mb-6 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                  {ind.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{ind.name}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{ind.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
